import { render, staticRenderFns } from "./PriceRules.vue?vue&type=template&id=1ab0333e&scoped=true"
import script from "./PriceRules.vue?vue&type=script&lang=js"
export * from "./PriceRules.vue?vue&type=script&lang=js"
import style0 from "./PriceRules.vue?vue&type=style&index=0&id=1ab0333e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab0333e",
  null
  
)

export default component.exports